module.exports = __webpack_public_path__ + "img/instagram.a1ca50dd.png";